<div class="attendance-main-dashboard-container">
  <div class="dashboard-header">
    <h1>
      <mat-icon>schedule</mat-icon>
      Attendance Management
    </h1>
    <p *ngIf="isAdmin">Manage employee attendance, clock in/out, reports, and salary calculations</p>
    <p *ngIf="isManager">Manage attendance data, import records, generate reports, and handle salary calculations</p>
    <p *ngIf="isAttendanceUser && !isManager">View today's attendance entries and manage clock in/out</p>
  </div>

  <div class="cards-grid">
    <!-- Today's Dashboard Card - Available for Admin only -->
    <mat-card class="feature-card" (click)="navigateToTodayDashboard()" *ngIf="isAdmin">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>today</mat-icon>
        </div>
        <h3>Today's Attendance</h3>
        <p>View all clock in/out entries for today with face verification status</p>
      </mat-card-content>
    </mat-card>

    <!-- Manager (Attendance Role) Cards -->
    <ng-container *ngIf="isManager">
      <!-- Employee Management Card -->
      <mat-card class="feature-card" (click)="navigateToEmployees()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>people</mat-icon>
          </div>
          <h3>Employee Management</h3>
          <p>Add, edit, and manage employee information including photos and salary details</p>
        </mat-card-content>
      </mat-card>

      <!-- Monthly Attendance Report Card -->
      <mat-card class="feature-card" (click)="navigateToMonthlyReport()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>calendar_month</mat-icon>
          </div>
          <h3>Monthly Report</h3>
          <p>Generate monthly attendance reports with employee daily hours and export to Excel</p>
        </mat-card-content>
      </mat-card>

      <!-- Manual Attendance Entry Card -->
      <mat-card class="feature-card" (click)="navigateToManualEntry()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>edit_calendar</mat-icon>
          </div>
          <h3>Manual Entry</h3>
          <p>Add attendance records for employees not on the fingerprint system</p>
        </mat-card-content>
      </mat-card>

      <!-- Import Individual Punches Card -->
      <mat-card class="feature-card" (click)="navigateToIndividualPunchImport()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>schedule</mat-icon>
          </div>
          <h3>Import Individual Punches</h3>
          <p>Import individual punch records from NgTeco (new format with separate in/out entries)</p>
        </mat-card-content>
      </mat-card>
    </ng-container>

    <!-- Admin Only Cards -->
    <ng-container *ngIf="isAdmin">
      <!-- Employee Management Card -->
      <mat-card class="feature-card" (click)="navigateToEmployees()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>people</mat-icon>
          </div>
          <h3>Employee Management</h3>
          <p>Add, edit, and manage employee information including photos and salary details</p>
        </mat-card-content>
      </mat-card>

      <!-- Clock In/Out Card -->
      <mat-card class="feature-card" (click)="navigateToClockInOut()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>fingerprint</mat-icon>
          </div>
          <h3>Clock In/Out</h3>
          <p>Record employee clock in and clock out with photo capture and face verification</p>
        </mat-card-content>
      </mat-card>

      <!-- Attendance Reports Card -->
      <mat-card class="feature-card" (click)="navigateToReports()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>assessment</mat-icon>
          </div>
          <h3>Attendance Reports</h3>
          <p>Generate detailed attendance reports by date range with face verification flags</p>
        </mat-card-content>
      </mat-card>

    <!-- Monthly Attendance Report Card -->
    <mat-card class="feature-card" (click)="navigateToMonthlyReport()">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>calendar_month</mat-icon>
        </div>
        <h3>Monthly Report</h3>
        <p>Generate monthly attendance reports with employee daily hours and export to Excel</p>
      </mat-card-content>
    </mat-card>

    <!-- Manual Attendance Entry Card -->
    <mat-card class="feature-card" (click)="navigateToManualEntry()">
      <mat-card-content>
        <div class="card-icon">
          <mat-icon>edit_calendar</mat-icon>
        </div>
        <h3>Manual Entry</h3>
        <p>Add attendance records for employees not on the fingerprint system</p>
      </mat-card-content>
    </mat-card>


      <!-- Import Attendance Card -->
      <mat-card class="feature-card" (click)="navigateToImport()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>upload_file</mat-icon>
          </div>
          <h3>Import Attendance</h3>
          <p>Import attendance data from Excel/CSV files (NgTeco timecard reports)</p>
        </mat-card-content>
      </mat-card>

      <!-- Import Individual Punches Card -->
      <mat-card class="feature-card" (click)="navigateToIndividualPunchImport()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>schedule</mat-icon>
          </div>
          <h3>Import Individual Punches</h3>
          <p>Import individual punch records from NgTeco (new format with separate in/out entries)</p>
        </mat-card-content>
      </mat-card>

      <!-- Device Management Card -->
      <mat-card class="feature-card" (click)="navigateToDevices()">
        <mat-card-content>
          <div class="card-icon">
            <mat-icon>devices</mat-icon>
          </div>
          <h3>Device Management</h3>
          <p>Manage IP address to friendly name mappings for attendance tracking</p>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
</div> 